import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';

// import CustomerProfile from '../Components/Mothrift/CustomerManagement/CustomerProfile';

const LayoutRoutes = () => {
  return (
    <Routes>
  <Route element={<AppLayout />}>
     {routes.map(({ path, Component }, i) => (
        <Route key={i} path={path} element={Component} />
     ))}
  </Route>
  <Route path="*" element={<div>Route Not Found. Current path: {window.location.pathname}</div>} />
</Routes>
  );
};

export default LayoutRoutes;